import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import './yes-no-dialog.styles.scss';
import { isNotEmpty } from '../../features/common/util.services';

export const YesNoDialog = (props: any) => {

  const handleClose = (onClose: any) => {
    onClose();
  }
  const handleOk = (onOk: any) => {
    onOk();
  }

  const getBGStyle = () => {
    if (props.isHorizontal) {
      return 'yesNoDialogContainer bg-horizontal';
    } else {
      return 'yesNoDialogContainer bg-vertical';
    }
  }

  const showYesBtn = isNotEmpty(props.showYesBtn) ? props.showYesBtn : true;
  const showNoBtn = isNotEmpty(props.showNoBtn) ? props.showNoBtn : true;
  const yesBtnText = isNotEmpty(props.yesBtnText) ? props.yesBtnText : 'Yes';
  const noBtnText = isNotEmpty(props.noBtnText) ? props.noBtnText : 'No';

  return (
    <Dialog {...props}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          width: 390
        },
      }}>
      <div className={getBGStyle()}>
        <div className="message-box-animation"></div>
        <div className="message">{props.message}</div>
        <div className="buttonPanel">
          {showNoBtn && <Button variant="contained" onClick={() => { handleClose(props.onClose) }} color="secondary">{noBtnText}</Button>}
          {showYesBtn && <Button variant="contained" onClick={() => { handleOk(props.onOk) }} color="primary">{yesBtnText}</Button>}
        </div>
      </div>
    </Dialog>
  );
}

export default YesNoDialog;